import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { GalleryItem } from '../interfaces';
import { GalleryState } from '../reducers/gallery.reducer';

export const galleryActions = createActionGroup({
  source: 'Einreichung - gallery',
  events: {
    'Set items': props<{ items: Array<GalleryItem> }>(),
    'Clear store': emptyProps(),
    'update item': props<Partial<GalleryItem>>(),
    'Load page success': props<{ page: any; pageId: string }>(),
    'Load page failed': props<{ error: any; pageId: string }>(),
    'Load page': props<{ applicationId: string | null; pageId: string; dataType: string }>(),
    'update state': props<Partial<GalleryState>>(),
  },
});
